// Module
var code = "<div class=\"setup\"> <div id=\"main-content-view\" ui-view=\"childcontent\" class=\"reset-ui-view\"></div> </div> ";
// Exports
export default code;